require('./jv.tracking.jobBoards.paramsFAC');

angular.module('jv.tracking.jobBoards.editCtrl', [
    'jv.tracking.jobBoards.paramsFAC'
    ])
     .controller('jobBoardEditCtrl', ['$scope', '$location','jobBoardDetails', 'jobBoardDataDeserializeFAC','jobBoardService','commonControllerActionsFAC','jobBoardDataValidationFAC','$rootScope',
        function ($scope, $location, jobBoardDetails, jobBoardDataDeserializeFAC, jobBoardService, commonControllerActionsFAC, jobBoardDataValidationFAC, $rootScope) {
            angular.extend($scope, commonControllerActionsFAC());
            $scope.jobBoard = jobBoardDetails;
            $scope.setNameAsDisabled = true;
            $scope.pageTitle = 'Update jobBoard: ' + $scope.jobBoard.name;
            $rootScope.flags = $rootScope.flags || {};
            $rootScope.flags.loading = false;

            $scope.save = function(){
                $scope.startValidation = true;
                if(jobBoardDataValidationFAC($scope.jobBoard)){
                    $rootScope.flags.loading = true;
                    var postData = jobBoardDataDeserializeFAC($scope.jobBoard);
                    jobBoardService.updateJobBoard(postData, function(response){
                        if(response && response.msgInfo === 200){
                            $location.path('/list/updated');
                        }
                    }, function(){
                        $location.path('/list/opserror/true');
                    });
                }
            };

            $scope.deleteNewVersion = function(versionNumber){
                delete $scope.jobBoard.versions[versionNumber];
            };
        }
    ]);
